import { createSharedPathnamesNavigation } from 'next-intl/navigation'

export const locales = [
  'th',
  'en',
  'zh',
  'km',
  'ja',
  'my',
  'ar',
  'vn',
  'de',
  'id',
  'ru',
]
export const localePrefix = 'always'

// redirect cause error when redirect to external url
export const { Link, usePathname, useRouter } = createSharedPathnamesNavigation(
  { locales, localePrefix }
)
